import {
    DesignSystemBorderRadius,
    DesignSystemIconSizing,
    DesignSystemRadius,
} from '@upheal/design-system/theme/design-system/types';

export type DesignSystemFeatureIconSize = DesignSystemIconSizing;

export const featureIconPadding: Record<DesignSystemFeatureIconSize, number> = {
    xxs: 0.25,
    xs: 0.5,
    sm: 0.5,
    md: 0.75,
    lg: 1,
    xl: 1.25,
    '2xl': 1.5,
};

export const featureIconBorderRadius: Record<
    DesignSystemFeatureIconSize,
    Record<DesignSystemRadius, DesignSystemBorderRadius>
> = {
    xxs: {
        full: 'full',
        none: 'none',
        rounded: 'xs',
    },
    xs: {
        full: 'full',
        none: 'none',
        rounded: 'sm',
    },
    sm: {
        full: 'full',
        none: 'none',
        rounded: 'md',
    },
    md: {
        full: 'full',
        none: 'none',
        rounded: 'md',
    },
    lg: {
        full: 'full',
        none: 'none',
        rounded: 'xl',
    },
    xl: {
        full: 'full',
        none: 'none',
        rounded: 'xl',
    },
    '2xl': {
        full: 'full',
        none: 'none',
        rounded: 'xl',
    },
};
